import React from 'react';
import classnames from 'classnames';

import styles from '../cms.module.scss';

const Table = ({
  value: {
    data,
    first_row_is_table_header: firstLineTh,
    first_col_is_header: firstColTh,
  },
}) => (
  <table className={styles.cms__table}>
    <tbody>
      {/* eslint-disable react/no-array-index-key */}
      {data.map((row, rowIndex) => (
        <tr key={rowIndex} className={styles['cms__table-row']}>
          {row.map((cell, cellIndex) => {
            const isTh = (firstLineTh && rowIndex === 0) || (firstColTh && cellIndex === 0);
            const Tag = isTh ? 'th' : 'td';
            const formattedCell = cell.split('\n').map((item, i) => (<span key={i}>{item} <br /></span>));

            return (
              <Tag
                key={cellIndex}
                className={classnames({
                  [styles['cms__table-cell']]: true,
                  [styles[`cms__table-cell--${Tag}`]]: true,
                })}
              >
                {formattedCell}
              </Tag>
            );
          })}
        </tr>
      ))}
      {/* eslint-enable */}
    </tbody>
  </table>
);

export default Table;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/Table/index.js